import React from "react"
import { Container, Row, Col } from "reactstrap"
import logoImg from "../../assets/images/logo/powered.png"

import Config, { ActiveClient } from "../../config";


const Footer = () => {

  //2024.03.15 - 1.0.0 - Initial Version
  //2024.03.18 - 1.0.1 
  //2024.03.20 - 1.0.2
  const softwareVersion = process.env.REACT_APP_VERSION; // Replace with your actual software version

  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={6}><a href={Config[Config.ActiveClient].webUrl}>Powered by {Config[Config.ActiveClient].fullName} © {new Date().getFullYear()} </a></Col>
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                {ActiveClient === "mypos" ? <img src={logoImg} alt="" height="24" /> : null}
                {/*  */}
                <span className="text-muted ms-1">Version {softwareVersion}</span>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer


/*
 * Version: 1.0.0
 * Date: March 15, 2024
 * Added Features:
 * - Initial Version
 */


/*
  * Version: 1.0.1
  * Date: March 18, 2024
  * Added Features:
  * Bug Fixes:
  * - Changed BOM calculation logic
  * - Promotion customer bundle added to the exclude/include list
*/


/*
  * Version: 1.0.2
  * Date: March 20, 2024
  * Added Features:
  * Bug Fixes:
  * - Department saving issue fixed
  * - Added messge to transaction save SP now the display message can be pass from the SP to display in the UI
  * - Allowed bin card product to be type with special characters
*/


/*
  * Version: 1.0.3
  * Date: March 22, 2024
  * Added Features:
  * - Added new feature the sage integration
  * Bug Fixes:
  * - TX_BOM and TX_VERIFICATION field values functions clearly defined
  * - TX_BOM do all the calculations and the UI changes accordingly
  * - TX_VERIFICATION do all the calculations and the UI changes accordingly
  * - TX_PRODUCTION check the add qty and deduct qty validations only
*/


/*
  * Version: 1.0.4
  * Date: March 23, 2024
  * Added Features:
  * Bug Fixes:
  * - intTX_ALLOWMINUS validation added to the lineAmount calculation function in the transaction
*/


/*
  * Version: 1.0.5
  * Date: March 27, 2024
  * Added Features:
  * Bug Fixes:
  * - More bug fixes in transaction. BOM and VERIFICATION and PRODUCTION validations added
*/


/*
  * Version: 1.0.6
  * Date: March 29, 2024
  * Added Features:
  * Bug Fixes:
  * - ALLOWMINUS validation changed to do better calculations
*/


/*
  * Version: 1.0.7
  * Date: March 29, 2024
  * Added Features:
  * Bug Fixes:
  * - Product fix gp calculation fixed
  * - Promotion location load changed to load only main locations
  * - Added special characters for product references
  * - Product default supplier validation changed to be able to add multiple suppliers (not for a single location)
*/


/*
  * Version: 1.0.8
  * Date: April 4, 2024
  * Added Features:
  * Bug Fixes:
  * - Average cost calculation fixed in transaction , avg cost display fixed
  * - Bom issues fixed in bill of materials
  * - Addition Deduction calculation fixed in transaction
*/


/*
  * Version: 1.0.9
  * Date: April 19, 2024
  * Added Features:
  * Bug Fixes:
  * - Changed they way reason types can add multiple transactions to single reason
  * - Added average cost calcculation to the transaction
  * - Miner changes and bug fixes in some master files
*/


/*
  * Version: 1.1.0
  * Date: May 13, 2024
  * Added Features:
  * Bug Fixes:
  * - Bom search and bom prodcut search changed to be validated with location code, earlier product cost was taken from M_TBLPROMASTER now it is taken from M_TBLPROINVENTORY
  * - Open item description , cost and price changing enabled in the transaction
  * - Delete button caption change to Cancel in the transactions
  * - Detail remark validation added to the transaction if TX_REMOVE_REFLOC_VALIDATION is set to 1
  * - From location and To location can not be same in the transaction now
*/


/*
  * Version: 1.1.1
  * Date: May 17, 2024
  * Added Features:
  * Bug Fixes:
  * - Added two new fields to product master to store the product POS production and Empty bittle
  * - Finishproduct production cost calculation changed in tranaction added new button for the calcualtion
*/


/*
  * Version: 1.1.2
  * Date: May 22, 2024
  * Added Features:
  * Bug Fixes:
  * - Removed bom decimal validation from the transaction and bill of materials as requested
*/


/*
  * Version: 1.1.3
  * Date: May 27, 2024
  * Added Features:
  * Bug Fixes:
  * - BOM SIH validation added
  * - TX_NOCANCELLATION added to the transaction to restrict the cancellation of the transaction
  * - 2024.05.29 - added cost column to bincard - no api changes
*/


/*
  * Version: 1.1.4
  * Date: May 31, 2024
  * Added Features:
  * Bug Fixes:
  * - Month end checking functionallity modified to check the month end for the current location
  * - cashbook changes
  * - Added two fields to check transaction is a ref1 and ref2 transaction
*/


/*
  * Version: 1.1.5
  * Date: June 5, 2024
  * Added Features:
  * - Added QTY update excel option to transactions
  * - Added password reset feature to the system, a user who have permission can reset the password of any user
  * - Added field to load remars from the referece transaction to the transaction
  * Bug Fixes:
  * - Reference tranaction SIH loading issue fixed where it was loading SIH from the header from location but it should load from the from location which user select.
*/


/*
  * Version: 1.1.6
  * Date: June 12, 2024
  * Added Features:
  * - Deduction amount calculation changes for wms to calculate that amount depend on the supplier contribution percentage
  * - Inbound capacity name display added
  * Bug Fixes:
  * - RefTXN not loading when the transaction called fiexed
*/

/*
  * Version: 1.1.7
  * Date: June 26, 2024
  * Added Features:
  * Bug Fixes:
  *
*/

/*
  * Version: 1.1.8
  * Date: June 28, 2024
  * Added Features:
  * Bug Fixes:
  * - Added product description to bincard
  * - Transaction Tax calculation changed to calculate the tax based on the tax on tax with SSC
  *
*/

/*
  * Version: 1.1.9
  * Date: July 4, 2024
  * Added Features:
  * Bug Fixes:
  * - Credit note payment disable issue fixed
  * - Only log location document loading feature added
  * - Only log location loads
*/


/*
  * Version: 1.2.0
  * Date: July 5, 2024
  * Added Features:
  * Bug Fixes:
  * - Supplier code saving issue fixed.
  * - Backoffice Invoice saving with qty 0 issue fixed.
  * - Approval Combination added to the transaction.
  * - Added Customer required and pricemode required message to the backoffice invoices.
  * - Transaction Tax calculation changed to calculate the tax based on the tax on tax.
*/

/*
  * Version: 1.2.1
  * Date: July 9, 2024
  * Added Features:
  * Bug Fixes:
  * - Cashbook transaction permisson added.
  * - Permisson saving to the headoffice.
*/

/*
  * Version: 1.2.2
  * Date: August 27, 2024
  * Added Features:
  * Bug Fixes:
  * - Batch Creation added
*/




//Reclasification Note is a note that is added to the transaction to explain the reason for the reclassification of the transaction.
//As an example if there is a set of items in a box and the box is sold as a single item but company wants to sell individual items in the box,
//then this note can be used to explain the reason for the reclassification of the transaction. deduct box and add individual items.




/* Tax Issues */
//What will happen if the company changes the transaction taxtypes after the transaction is saved?
//What will happen if the company changes the transaction taxtypes after the transaction is saved and the transaction is already posted?
//Tax calculation happen at one place in the transaction, if the tax calculation is changed then it will be changed for all the transactions which are already saved too.



//IF TX_PRODUCTION = 1 THEN IT CHECK DET_UNITQTY AND DET_FUNITQTY
//IF 